<template>
  <section v-on:click="sectionClicked">
    <Header ref="header"/>
    <div class="notFound" v-if="comingSoon">
      <h4>Coming Soon</h4>
    </div>
    <div class="notFound" v-else-if="notFound">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>Halaman tidak ditemukan</h2>
      <p>Halaman yang kamu cari tidak ditemukan</p>
    </div>
    <div class="loading" v-else-if="loading"></div>
    <div v-else>
      <div class="slideShow" v-if="allSlider && allSlider.length > 0">
        <splide :slides="allSlider">
          <splide-slide v-for="(item, index) in allSlider" :key="index">
            <div class="slideItem" :style="{'background-image': `url(${item.media.imageLg})`}"
              v-on:click="sliderClicked(item)">
              <div class="sic">
                <h4>{{item.title}}</h4>
                <a :href="item.buttonUrl" class="btn"
                  v-if="item.buttonUrl && item.buttonLabel">{{item.buttonLabel}}</a>
              </div>
            </div>
          </splide-slide>
        </splide>
      </div>

      <div class="allContentCnt amagram" v-if="amagram && amagram.length > 0">
        <h2 class="sectionTitle">
          Amagram
          <a href="/amagram">Lihat semua</a>
        </h2>
        <div class="allContent">
          <div class="contentSc artc">
            <div class="contentCnt">
              <div class="contentItem artc" v-for="(item, index) in amagram" :key="index"
                :class="item.type">
                <div :class="{contentImg: true, shortImg: item.publishYear < 2018}">
                  <div :class="{theImg: true, noImg: !item.thumb}"
                    :style="{'background-image': `url(${item.thumb})`}">
                    <router-link :to="`/${item.category.slug}/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo">
                  <div class="category">
                    <a :href="`/${item.category.slug}`">{{item.category.name}} Terbaru</a>
                  </div>
                  <h4><router-link :to="`/${item.category.slug}/${item.slug}`">
                      {{item.title | substr(65, '...')}}
                  </router-link></h4>
                  <div class="date">
                    <router-link :to="`/${item.category.slug}/${item.slug}`">
                      <span v-if="item.viewCountStr > 1000000">
                        {{Math.floor(item.viewCountStr / 1000000)}}M
                      </span>
                      <span v-else-if="item.viewCountStr > 1000">
                        {{Math.floor(item.viewCountStr / 1000)}}K
                      </span>
                      <span v-else>{{item.viewCountStr}}</span>
                      views &bull;
                      {{item.publishDate | moment('MMM YYYY')}}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="contentItem artc" v-if="amagramYear1"
                :class="amagramYear1.type">
                <div :class="{contentImg: true, shortImg: amagramYear1.publishYear < 2018}">
                  <div :class="{theImg: true, noImg: !amagramYear1.thumb}"
                    :style="{'background-image': `url(${amagramYear1.thumb})`}">
                    <router-link
                      :to="`/${amagramYear1.category.slug}/edition/${amagramYear1.publishYear}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo tc">
                  <h4><router-link
                    :to="`/${amagramYear1.category.slug}/edition/${amagramYear1.publishYear}`">
                    Amagram {{amagramYear1.publishYear}}
                  </router-link></h4>
                </div>
              </div>
              <div class="contentItem artc" v-if="amagramYear2"
                :class="amagramYear2.type">
                <div :class="{contentImg: true, shortImg: amagramYear2.publishYear < 2018}">
                  <div :class="{theImg: true, noImg: !amagramYear2.thumb}"
                    :style="{'background-image': `url(${amagramYear2.thumb})`}">
                    <router-link
                      :to="`/${amagramYear2.category.slug}/edition/${amagramYear2.publishYear}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo tc">
                  <h4><router-link
                    :to="`/${amagramYear2.category.slug}/edition/${amagramYear2.publishYear}`">
                    Amagram {{amagramYear2.publishYear}}
                  </router-link></h4>
                </div>
              </div>
              <div class="contentItem artc" v-if="amagramYear3"
                :class="amagramYear3.type">
                <div :class="{contentImg: true, shortImg: amagramYear3.publishYear < 2018}">
                  <div :class="{theImg: true, noImg: !amagramYear3.thumb}"
                    :style="{'background-image': `url(${amagramYear3.thumb})`}">
                    <router-link
                      :to="`/${amagramYear3.category.slug}/edition/${amagramYear3.publishYear}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo tc">
                  <h4><router-link
                    :to="`/${amagramYear3.category.slug}/edition/${amagramYear3.publishYear}`">
                    Amagram {{amagramYear3.publishYear}}
                  </router-link></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="featuredCnt" v-if="leaderNewsletter && leaderNewsletter.length > 0">
        <div class="more">
          <router-link to="/editor-pick">
            Selengkapnya
            <img src="../assets/arrow-right-purple.png">
          </router-link>
        </div>

        <div class="featuredSc">
          <div class="featured">
            <div class="featuredItem" v-for="(item, index) in amagram"
              :key="index">
              <div class="featuredImg"
                :style="{'background-image': `url(${item.thumb})`}"
                v-if="item.thumb">
                <router-link :to="`/${item.category.slug}/${item.slug}`"
                  class="lnk"></router-link>
              </div>
              <div class="featuredImg noImg" v-else>
                <router-link :to="`/${item.category.slug}/${item.slug}`"
                  class="lnk"></router-link>
              </div>
              <div class="featuredInfo">
                <div :class="{contentLove: true, favorited: item.favorited,
                  animating: animatingHeartC === item.id, animating2: animatingHeart2C === item.id}"
                  v-on:click="favoriteFeatured(index, item)"></div>
                <div class="category">
                  <router-link :to="`/${item.category.slug}`">
                    {{item.category.name}}
                  </router-link>
                </div>
                <h4>
                  <router-link :to="`/${item.category.slug}/${item.slug}`">
                    {{item.title}}
                  </router-link>
                </h4>
                <div class="date">
                  <router-link :to="`/${item.category.slug}/${item.slug}`">
                    {{item.viewCountStr}} views &bull;
                    {{item.publishDate | moment('MMM YYYY')}}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="allContentCnt" v-if="leaderNewsletter && leaderNewsletter.length > 0">
        <h2 class="sectionTitle">
          Leader Newsletter
          <a href="/leader-newsletter">Lihat semua</a>
        </h2>
        <div class="allContent">
          <div class="contentSc artc">
            <div class="contentCnt">
              <div class="contentItem artc" v-for="(item, index) in leaderNewsletter" :key="index">
                <div class="contentImg">
                  <div :class="{theImg: true, noImg: !item.thumb}"
                    :style="{'background-image': `url(${item.thumb})`}">
                    <router-link :to="`/${item.category.slug}/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo">
                  <div :class="{contentLove: true, favorited: item.favorited,
                    animating: animatingHeart === item.id, animating2: animatingHeart2 === item.id}"
                    v-on:click="favorite(index, item)"></div>
                  <div class="category">
                    <router-link :to="`/${item.category.slug}`">{{item.category.name}}</router-link>
                  </div>
                  <h4><router-link :to="`/${item.category.slug}/${item.slug}`">
                      {{item.title | substr(65, '...')}}
                  </router-link></h4>
                  <div class="date">
                    <router-link :to="`/${item.category.slug}/${item.slug}`">
                      {{item.viewCountStr}} views &bull;
                      {{item.publishDate | moment('MMM YYYY')}}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="allContentCnt bsm" v-if="bsm && bsm.length > 0">
        <h2 class="sectionTitle bsm">Informasi Produk & Bisnis</h2>
        <div class="allContent">
          <div class="contentSc artc">
            <div class="contentCnt">
              <div class="contentItem artc product bsm"
                v-for="(item, index) in bsm" :key="index">
                <div class="contentImg">
                  <div class="theImg" v-if="item.media"
                    :style="{'background-image': `url(${item.media.imageMd})`}">
                    <router-link :to="`/category/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                  <div class="theImg noImg" v-else>
                    <router-link :to="`/category/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo">
                  <h4><router-link :to="`/category/${item.slug}`">
                      {{item.name | substr(65, '...')}}
                  </router-link></h4>
                </div>
              </div>
              <template v-if="landingPages.length > 0">
                <div class="contentItem artc product bsm"
                  v-for="(item, index) in landingPages" :key="`lp${index}`">
                  <div class="contentImg">
                    <div class="contentLocked" v-if="item.private === 1"></div>
                    <div class="theImg" v-if="item.thumb"
                      :style="{'background-image': `url(${item.thumb.imageMd})`}">
                      <router-link :to="`/landing/${item.code}`"
                        class="lnk"></router-link>
                    </div>
                    <div class="theImg noImg" v-else>
                      <router-link :to="`/landing/${item.code}`"
                        class="lnk"></router-link>
                    </div>
                  </div>
                  <div class="contentInfo">
                    <h4><router-link :to="`/landing/${item.code}`">
                      {{item.title}}
                      <template v-if="1>2">
                        <span v-if="item.private">
                          <img src="../assets/private.png">
                          Required SSO Login</span>
                        <span v-else>
                          <img src="../assets/public.png">
                          Public Access</span>
                      </template>
                    </router-link></h4>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="allContentCnt bsm"
        v-if="product && product.submenu && product.submenu.length > 0">
        <h2 class="sectionTitle">Produk & Bisnis</h2>
        <div class="allContent">
          <div class="contentSc artc">
            <div class="contentCnt">
              <div class="contentItem artc product"
                v-for="(item, index) in product.submenu" :key="index">
                <div class="contentImg">
                  <div class="theImg" v-if="item.media"
                    :style="{'background-image': `url(${item.media.imageMd})`}">
                    <router-link :to="`/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                  <div class="theImg noImg" v-else>
                    <router-link :to="`/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo">
                  <h4><router-link :to="`/${item.slug}`">
                      {{item.name | substr(65, '...')}}
                  </router-link></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import Header from '@/components/Header.vue';

import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
  name: 'home',
  components: {
    Splide, SplideSlide, Header,
  },
  data() {
    return {
      notFound: false,
      comingSoon: false,
      loading: true,
      allSlider: [],
      featured: [],
      amagram: [],
      amagramYear1: null,
      amagramYear2: null,
      amagramYear3: null,
      bsm: [],
      product: null,
      leaderNewsletter: [],
      bulletin10x: [],
      animatingHeart: null,
      animatingHeart2: null,
      animatingHeartC: null,
      animatingHeart2C: null,
      animatingHeartG: null,
      animatingHeart2G: null,
      landingPages: [],
    };
  },
  methods: {
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    sliderClicked(item) {
      if (item.buttonUrl) window.location.href = item.buttonUrl;
    },
    goto(uri) {
      this.$router.push(uri);
    },
  },
  mounted() {
    document.title = this.$config.appName;
    this.$http.get(this.$config.uri('slider/all')).then((r) => {
      this.allSlider = (r.data.status === 200) ? r.data.data : [];
    });
    this.$http.get(this.$config.uri('content/parent/amagram')).then((r) => {
      const category = (r.data.status === 200) ? r.data.data : null;
      if (!category) {
        this.loading = false;
        this.comingSoon = true;
        return;
      }
      const amUri = `content/all?parentId=${category.id}&limit=1`;
      this.$http.get(this.$config.uri(amUri)).then((rr) => {
        this.loading = false;
        this.amagram = (rr.data.status === 200) ? rr.data.data : [];
      });
      const d = new Date();
      const y = d.getFullYear();
      const amUri1 = `content/all?parentId=${category.id}&limit=2&year=${y}`;
      this.$http.get(this.$config.uri(amUri1)).then((rr) => {
        if (rr.data.status !== 200) this.amagramYear1 = null;
        else if (rr.data.data[1]) this.amagramYear1 = rr.data.data[1]; // eslint-disable-line
        else [this.amagramYear1] = rr.data.data;
      });
      const amUri2 = `content/all?parentId=${category.id}&limit=1&year=${y - 1}`;
      this.$http.get(this.$config.uri(amUri2)).then((rr) => {
        this.amagramYear2 = (rr.data.status === 200) ? rr.data.data[0] : [];
      });
      const amUri3 = `content/all?parentId=${category.id}&limit=1&year=${y - 2}`;
      this.$http.get(this.$config.uri(amUri3)).then((rr) => {
        this.amagramYear3 = (rr.data.status === 200) ? rr.data.data[0] : [];
      });
    });
    this.$http.get(this.$config.uri('content/parent/bsm/ok?home=y')).then((r) => {
      this.bsm = (r.data.status === 200) ? r.data.data : [];
    });

    // eslint-disable-next-line
    const landingData = JSON.parse('{"status":200,"data":[{"id":2,"isDeleted":0,"title":"Amway Social Selling","thumbId":2377,"description":"Jadilah The Next Amway Content Creator. Gunakan kreativitas Anda untuk menjangkau target audiens dan meningkatkan brand awareness.","private":1,"code":"amway-social-selling","authorId":2,"author":{"id":2,"name":"Publication Admin","phone":null,"email":"admin@gmail.com","password":"693313193a016bed9438d5d91f652d09-73f548e31b8","role":"admin","otp":null,"created":1619525203,"updated":null,"lastLogin":1666335998,"isDeleted":0,"birthDate":null,"emailVerified":0,"about":"","avatar":null,"forgotPwdToken":null,"nanoId":null,"whatsappDelivered":0,"linkVisited":0,"smsDelivered":0,"city":null,"province":null,"isUser":0,"extNo":null,"roleId":null},"thumb":{"id":2377,"name":"social-selling.jpg","filename":"socialselling.jpg","uploaded":1664910184,"updated":null,"mimetype":"image/jpeg","type":"image","mainThumb":null,"vid1080p":null,"vid720p":null,"vid480p":null,"vid360p":null,"thumb1":null,"thumb2":null,"thumb3":null,"thumb4":null,"status":"processed","progress":0,"customThumb":0,"vidDuration":null,"isDeleted":0,"author":2,"pdfCover":null,"pdfPages":null,"size":null,"ytVideoId":null,"width":800,"height":800,"ratio":1,"genre":null,"slug":"socialselling","imageBl":"https://demoapi.amwaypublication.com/media/image/blured-socialselling.jpg","imageTh":"https://demoapi.amwaypublication.com/media/image/thumb-socialselling.jpg","imageSm":"https://demoapi.amwaypublication.com/media/image/small-socialselling.jpg","imageMd":"https://demoapi.amwaypublication.com/media/image/medium-socialselling.jpg","imageLg":"https://demoapi.amwaypublication.com/media/image/large-socialselling.jpg"}},{"id":1,"isDeleted":0,"title":"Atmosphere Mini","thumbId":2378,"description":"Di rumah atau di mobil? Sebut saja, karena kami memiliki penjernih udara untuk keduanya. Dengan teknologi yang lebih baik dari HEPA standar, filter-nya mampu memfiltrasi partikel PM2,5 serta memonitor kualitas udara secara menyeluruh. Partner paling pas untuk mendukung gaya hidup sehatmu!","private":0,"code":"atmosphere-mini","authorId":2,"author":{"id":2,"name":"Publication Admin","phone":null,"email":"admin@gmail.com","password":"693313193a016bed9438d5d91f652d09-73f548e31b8","role":"admin","otp":null,"created":1619525203,"updated":null,"lastLogin":1666335998,"isDeleted":0,"birthDate":null,"emailVerified":0,"about":"","avatar":null,"forgotPwdToken":null,"nanoId":null,"whatsappDelivered":0,"linkVisited":0,"smsDelivered":0,"city":null,"province":null,"isUser":0,"extNo":null,"roleId":null},"thumb":{"id":2378,"name":"atmosphere-mini.jpg","filename":"atmospheremini.jpg","uploaded":1664910184,"updated":null,"mimetype":"image/jpeg","type":"image","mainThumb":null,"vid1080p":null,"vid720p":null,"vid480p":null,"vid360p":null,"thumb1":null,"thumb2":null,"thumb3":null,"thumb4":null,"status":"processed","progress":0,"customThumb":0,"vidDuration":null,"isDeleted":0,"author":2,"pdfCover":null,"pdfPages":null,"size":null,"ytVideoId":null,"width":800,"height":800,"ratio":1,"genre":null,"slug":"atmospheremini","imageBl":"https://demoapi.amwaypublication.com/media/image/blured-atmospheremini.jpg","imageTh":"https://demoapi.amwaypublication.com/media/image/thumb-atmospheremini.jpg","imageSm":"https://demoapi.amwaypublication.com/media/image/small-atmospheremini.jpg","imageMd":"https://demoapi.amwaypublication.com/media/image/medium-atmospheremini.jpg","imageLg":"https://demoapi.amwaypublication.com/media/image/large-atmospheremini.jpg"}}]}')
    this.landingPages = landingData.data;
    // this.$http.get(this.$config.uri('landing/all')).then((r) => {
    //   this.landingPages = (r.data.status === 200) ? r.data.data : [];
    // });
  },
};
</script>

<style lang="scss">
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 500px;
      margin-bottom: 40px;
    }
    h2{
      margin: 0 0 4px;
      font-size: 30px;
      line-height: 1;
    }
    h4{
      margin: 0;
      font-size: 50px;
      line-height: 1;
    }
    p{
      margin: 0;
    }
  }

.slideShow{
  overflow: hidden;
  @media (min-width: 1480px) {
    width: 1180px;
    margin: 20px auto 0;
    border-radius: 10px;
    box-shadow: 2px 2px 2px rgba(0,0,0,.1);
  }
  .splide__slide{
    height: 460px;
    position: relative;
    @media (min-width: 1480px) {
      height: 348px;
    }
    @media (max-width: 669px) {
      height: 40vw;
    }
    .slideItem{
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      .sic{
        position: absolute;
        left: 100px; top: 50%; transform: translateY(-50%);
      }
      h4{
        margin: 0 0 10px;
        color: #fff;
        color: #002f5f;
        font-size: 50px;
      }
      .btn{
        background-color: #002f5f;
        padding: 0 20px;
        height: 44px;
        line-height: 44px;
        font-size: 22px;
        display: inline-block;
        border-radius: 3px;
        color: #fff;
        border: none;
        font-weight: 600;
        outline: 0;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #004c9a;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.loading{
  height: calc(100vh - 64px);
  background-image: url(../assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}
.sectionTitle{
  font-size: 32px;
  line-height: 1.3;
  margin: 0 auto 16px;
  max-width: 1180px;
  a{
    font-size: 17px;
    font-weight: 600;
    display: inline-block;
    border: #002f5f 1px solid;
    padding: 6px 10px 5px;
    border-radius: 2px;
    margin-top: 0px;
    float: right;
    transition: all .3s ease;
    &:hover{
      background-color: #002f5f;
      color: #fff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  @media (max-width: 1300px) {
    max-width: 1140px
  }
  @media (max-width: 1220px) {
    margin: 0 20px 16px;
    max-width: none;
    font-size: 26px;
  }
  @media (max-width: 680px) {
    margin: 0 16px 30px;
    font-size: 18px;
  }
  &.bsm{
    @media (max-width: 680px) {
      margin-bottom: 10px;
    }
  }
}

.featuredCnt{
  padding: 60px 0;
  @media (max-width: 1300px) {
    padding: 40px 0;
  }
  @media (max-width: 669px) {
    padding: 20px 0 36px;
  }
  .featuredSc{
    max-width: 1180px;
    margin: 0 auto;
    box-sizing: border-box;
    @media (max-width: 1300px) {
      margin: 0 20px;
      max-width: none;
    }
    @media (max-width: 980px) {
      overflow-x: auto;
      margin-left: 0;
      margin-right: 0;
      padding-left: 30px;
      padding-bottom: 10px;
    }
    @media (max-width: 669px) {
      padding-left: 26px;
    }
  }
  .more{
    float: right;
    margin: 10px 20px 0 0;
    display: none;
    @media (max-width: 674px) {
      // margin-top: 3px;
    }
    img{
      height: 16px;
      float: right;
      margin: 3px 0 0 5px;
    }
    a{
      color: #6e35a4;
      &:hover{
        opacity: .9;
      }
    }
  }
  .featured{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    justify-content: center;
    @media (max-width: 980px) {
      width: 1200px;
    }
    @media (max-width: 669px) {
      width: 1000px;
    }
    .featuredItem{
      width: calc(25% - 20px);
      height: 500px;
      // background-color: #333;
      border-radius: 3px;
      margin: 0 10px 20px 10px;
      position: relative;
      overflow: hidden;
      color: #e5e5e5;
      transition: all .2s ease;
      @media (max-width: 1300px) {
        height: 30vw;
      }
      @media (max-width: 980px) {
        margin: 0 20px 0 0;
        height: 380px;
        transform: none !important;
      }
      @media (max-width: 669px) {
        height: 300px;
        margin: 0 16px 0 0;
        width: calc(25% - 16px);
      }
      a{
        color: #e5e5e5;
        text-decoration: none;
        &:hover{
          color: #fff;
        }
      }
      .featuredImg{
        position: absolute;
        top: -2px; right: -2px; bottom: -2px; left: -2px;
        background-size: cover;
        background-position: center;
        transition: all .2s ease;
        &.noImg{
          background-color: #999;
          background-image: url(../assets/image-white.png);
          background-size: 64px auto;
          background-repeat: no-repeat;
          background-position: center;
        }
        .lnk{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          display: block;
          z-index: 2;
        }
      }
      &:hover{
        transform: scale(1.05);
        .featuredImg{
          // left: -20px; right: -20px; top: -20px; bottom: -20px;
        }
      }
      .featuredInfo{
        position: absolute;
        left: 0; bottom: 0; right: 0;
        padding: 50px 40px 10px 20px;
        border-radius: 3px;
        z-index: 3;
        background-image: linear-gradient(to top, rgba(0,0,0,.7), transparent);
        .lnk{
          position: absolute;
          left: 0; top: 0; right: 0;
          height: 50px;
        }
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 12px; bottom: 15px;
          background-image: url(../assets/heart-white.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          border-radius: 50%;
          &:hover{
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          font-weight: 600;
          font-size: 12px;
        }
        h4{
          margin: 0 0 6px;
          font-size: 20px;
          line-height: 1.2;
          @media (max-width: 1100px) {
            font-size: 16px;
          }
        }
        .liveClass{
          color: #ff4e45;
          border: #ff4e45 1px solid;
          border-radius: 3px;
          padding: 5px 6px 4px;
          margin: 6px 0 2px;
          background-color: rgba(0,0,0,.5);
          font-size: 14px;
          display: inline-block;
          font-weight: 500;
          line-height: 1;
        }
        .teacher{
          margin: 10px 0 8px;
          position: relative;
          padding-left: 36px;
          .icon{
            width: 30px; height: 30px;
            background-color: #fb7cb3;
            position: absolute;
            border-radius: 50%;
            left: 0; top: -5px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-position: center;
            background-size: cover;
            span{
              text-transform: uppercase;
              font-size: 12px;
            }
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
          h4{
            font-size: 17px;
            font-weight: 500;
            margin: 0;
          }
        }
        .teacherIcons{
          position: relative;
          display: flex;
          align-items: center;
          margin: 5px 0 3px 10px;
          .icon{
            width: 30px; height: 30px;
            background-color: #fb7cb3;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-position: center;
            background-size: cover;
            margin-left: -10px;
            span{
              text-transform: uppercase;
              font-size: 12px;
            }
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
          h4{
            font-size: 17px;
            font-weight: 500;
            padding-left: 10px;
            padding-top: 1px;
            margin: 0;
          }
        }
        .pricing{
          font-size: 16px;
          margin: 8px 0;
          .thePrice{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
            position: relative;
            padding-left: 22px;
            &:before{
              content: "";
              position: absolute;
              left: 0; top: 0;
              width: 16px; height: 16px;
              background-image: url(../assets/private-white.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.purchased{
              &:before{
                background-image: url(../assets/checkmark.png);
                top: 1px;
              }
            }
          }
        }
        .date{
          font-size: 12px;
        }
      }
    }
  }
}
.allContentCnt{
  padding-bottom: 40px;

  margin-top: 40px;
  &.amagram{
    @media (max-width: 680px) {
      padding-bottom: 0;
    }
  }
  &.bsm{
    @media (max-width: 680px) {
      padding-top: 0;
    }
  }
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      margin: 0 20px;
      max-width: none;
    }
    @media (max-width: 960px) {
      margin: 0;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      justify-content: center;
      width: calc(100% + 20px);
    }
    .contentItem{
      width: calc(20% - 20px);
      margin: 0 10px;
      @media (max-width: 680px) {
        width: calc(50% - 16px);
        margin: 0 8px 40px;
      }
      &.bsm{
        @media (max-width: 680px) {
          width: calc(100% - 16px);
          margin: 0 8px 40px;
        }
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        height: 400px;
        border-radius: 2px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        transition: all .3s ease;
        &:hover{
          transform: scale(1.02);
        }
        @media (max-width: 1100px) {
          // height: 220px;
        }
        @media (max-width: 669px) {
          // margin-bottom: 10px;
        }
        .contentLocked{
          position: absolute;
          width: 26px; height: 26px;
          z-index: 3;
          right: 16px; top: 16px;
          &:after{
            width: 100%; height: 100%;
            position: absolute;
            left: 0; top: 0;
            content: "";
            background-image: url(../assets/private.png);
            background-size: 100% auto;
            background-position: center;
            background-repeat: no-repeat;
            z-index: 1;
            opacity: .65;
          }
          &:before{
            width: 100%; height: 100%;
            position: absolute;
            left: 1px; top: -1px;
            content: "";
            // background-image: url(../assets/private-white.png);
            background-size: 100% auto;
            background-position: center;
            background-repeat: no-repeat;
            z-index: 3;
          }
        }
        .theImg{
          position: absolute;
          top: -2px; right: -2px; bottom: -2px; left: -2px;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      &.html{
        .contentImg{
          .theImg.noImg{
            background-color: #ffefe4;
            background-image: url(../assets/html.png) !important;
            background-size: 76px auto;
          }
        }
      }
      &.audio{
        .contentImg{
          .theImg.noImg{
            background-color: #d9d6e4;
            background-image: url(../assets/musical-note.svg) !important;
            background-size: 76px auto;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 40px 0 5px;
        &.tc{
          text-align: center;
        }
        @media (max-width: 669px) {
          padding-left: 3px;
        }
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          @media (max-width: 1340px) {
            font-size: 17px;
          }
          span{
            display: block;
            font-size: 15px;
            font-weight: 400;
            opacity: .74;
            margin-top: 8px;
            color: #444;
            img{
              height: 16px;
              margin: 1px 4px -1px 0;
            }
          }
          a{
            transition: all .3s ease;
            &:hover{
              color: #004c9a;
            }
          }
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
    }
  }
}

.allContentCnt{
  padding: 40px 0 20px;
  @media (max-width: 680px) {
    padding: 20px 0;
  }
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      max-width: none;
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      justify-content: left;
      @media (max-width: 680px) {
        margin: 0 -8px;
      }
    }
    .contentItem{
      width: calc(25% - 20px);
      margin: 0 10px;
      @media (max-width: 680px) {
        width: calc(50% - 16px);
        margin: 0 8px 40px;
      }
      &.bsm{
        @media (max-width: 680px) {
          width: calc(100% - 16px);
          margin: 0 8px 40px;
        }
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        height: 500px;
        border-radius: 2px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        @media (max-width: 1300px) {
          height: 480px;
        }
        @media (max-width: 1220px) {
          height: 40vw;
        }
        @media (max-width: 680px) {
          height: 78vw;
        }
        &.shortImg{
          height: 400px;
          @media (max-width: 1300px) {
            height: 380px;
          }
          @media (max-width: 1220px) {
            height: 30vw;
          }
          @media (max-width: 680px) {
            height: 68vw;
          }
        }
        .theImg{
          position: absolute;
          top: -2px; right: -2px; bottom: -2px; left: -2px;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 0 0 5px;
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          @media (max-width: 1340px) {
            font-size: 17px;
          }
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
      &.product{
        margin-bottom: 60px;
        @media (max-width: 680px) {
          margin-bottom: 40px;
        }
        .contentImg{
          height: 280px;
        }
        .contentInfo{
          text-align: center;
        }
      }
      &.bsm{
        width: calc(50% - 20px);
        @media (max-width: 680px) {
          width: calc(100% - 16px);
          margin: 0 8px 40px;
        }
        .contentImg{
          height: 460px;
          @media (max-width: 960px) {
            height: 380px;
          }
          @media (max-width: 680px) {
            height: 340px;
          }
        }
        .contentInfo{
          h4{
            font-size: 30px;
          }
        }
      }
    }
  }
}


@keyframes heartAnimation {
  from {
    transform: scale(.4);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes heartAnimation2 {
  from {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}

</style>
